import React from 'react';
import styled from 'styled-components';
import { breakpoints } from '@/layouts/breakpoints';

const StyledComp = styled.div`
  padding: 5rem 40px 0;
  max-width: 1400px;
  margin: 0 auto;

  .quote {
    max-width: 28rem;
    margin: 0 0 240px auto;
    text-align: right;
    font-style: italic;
    font-size: 1.75rem;
    line-height: 1.35;
    color: var(--black);
  }

  .intro {
    display: grid;
    grid-template-columns: 1fr 2fr;
    gap: 2.5rem;
    padding-bottom: 3rem;

    h2 {
      font-size: 1.125rem;
      font-weight: 600;
      color: var(--black);
      margin: 0;
    }
  }

  .columns {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2rem;

    p {
      margin: 0;
      font-size: 0.9375rem;
      line-height: 1.6;
      color: rgba(var(--greyr), 1);
    }
  }

  .image-wrap {
    margin-top: 3rem;
    border-radius: 6px;
    overflow: hidden;
    aspect-ratio: 16 / 9;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
  }

  @media (max-width: 768px) {

    .quote {
      font-size: 1.375rem;
      margin-bottom: 4rem;
    }

    .intro {
      grid-template-columns: 1fr;
      gap: 1rem;
    }

    .columns {
      grid-template-columns: 1fr;
      gap: 1.5rem;
    }
  }

  @media (max-width: ${breakpoints.small}) {
    padding: 3rem 24px 0;
  }
`;

const Comp = ({}) => {
  return (
    <StyledComp>
      <div className="quote serif">
        &ldquo;Wall Street&rsquo;s best data was never meant to leave Wall
        Street.&rdquo;
      </div>

      <div className="intro">
        <h2>Why Axion exists</h2>
      </div>

      <div className="columns">
        <p>
          For decades, real company intelligence, clean
          fundamentals, structured filings, and alternative data lived
          inside institutional terminals costing tens of thousands a year.
          If you weren't inside a bank or a fund, you built your own
          pipeline from scratch. The information existed. The
          infrastructure to work with it didn't.
        </p>
        <p>
          Axion exists to close that gap. One Python SDK and REST API puts
          market data, company fundamentals, SEC filings, insider activity,
          sentiment, ESG, credit ratings, and supply chain intelligence behind a
          single interface. It's a financial data API built for research,
          not just retrieval. Install it, authenticate, and you're
          pulling structured, model-ready data in minutes and not at institutional pricing.
        </p>
        <p>
          Financial intelligence has been stuck in the 20th century for
          too long. Gatekept by cost and complexity while the rest
          of software moved on. Axion is a bet that the next generation of
          research is built on open, programmatic infrastructure instead
          of legacy terminals. Democratizing access to proprietary
          financial data isn't a feature we shipped, it's why we exist.
        </p>
      </div>

      <div className="image-wrap">
        <img src="/verify.png" alt="Stone pillar detail" />
      </div>
    </StyledComp>
  );
};

export default Comp;
